//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['property'], // Property object
    data: function data() {
        return {
            toggleMediaGallery: false,
            activeGalleryName: 'main',
            activeGalleryImage: false,
            loading: true,
            website: false,
            files: [],
            currentPage: 'Page List',
            role: window.user.role
        };
    },

    methods: {
        deploySite: function deploySite() {
            var _this = this;

            console.log('Got a deploy', this.website);

            var site = this.website.id;

            if (!site) {
                return false;
            }

            this.loading = true;

            axios.post('/prototype/website/' + site + '/deploy').then(function (response) {
                _this.loading = false;
                _this.$snotify.success('Website deployed!');
            }).catch(function (error) {
                _this.loading = false;
                console.log('error: ', error);
                _this.$snotify.error('There was an error!');
            });
        },
        viewFolder: function viewFolder(folder) {
            var image = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            console.log('view-folder event fired on website main, folder = ' + folder);
            this.activeGalleryName = folder;
            this.activeGalleryImage = image;
            this.toggleMediaGallery = Math.floor(Math.random() * 1000);
        },
        refreshPropertyWebsite: function refreshPropertyWebsite(propertyId) {
            var _this2 = this;

            var website = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            // only refresh if website object is false
            if (!website) {
                axios.get('/prototype/website/' + propertyId).then(function (response) {
                    if (response.data.error) {
                        _this2.$snotify.error('Error refreshing property website data: ' + response.data.error);
                    } else if (response.data) {
                        _this2.website = response.data;
                        _this2.loading = false;
                    }
                });
            } else {
                this.website = website;
            }
        }
    },
    mounted: function mounted() {
        var $el = this;

        if (this.property && !this.property.disposition_date) {
            this.refreshPropertyWebsite(this.property.id);
        }

        Event.$on('show-property-website', function () {
            Event.$emit('refresh-property-website', $el.property.id);
        });
    },
    created: function created() {
        var _this3 = this;

        Event.$on('current-page', function (page) {
            _this3.currentPage = page;
        });

        Event.$on('deploy-site', function () {
            _this3.deploySite();
        });

        Event.$on('view-folder', this.viewFolder);

        /*
        @TODO - persistant state 'website' passed as prop to sub components
         What we need here is an event that gets called on the save() method of the subcomponents
        This event should get a website.id param, or perhaps a property.id
        get from WebsiteController::show, return website object as json - use request->type to toggle return format
         */
        Event.$on('refresh-property-website', function (propertyId) {
            return _this3.refreshPropertyWebsite(propertyId);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('current-page');
        Event.$off('deploy-site');
        Event.$off('view-folder');
        Event.$off('refresh-property-website');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/PropertyWebsite.vue
// module id = CVSw
// module chunks = 0 1